import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMessageCircle, FiArrowUpRight } = FiIcons;

function ContactSection() {
  return (
    <section className="contact-section section-pad" id="contact">
      <div className="contact-inner page-width">
        <div>
          <span className="eyebrow">Take the first step</span>
          <h2>Ready to feel more confident?</h2>
          <p>Call or message Milan to talk about your next lesson.</p>
        </div>
        <div className="contact-actions">
          <a className="button button-primary" href="tel:0433037815"><SafeIcon icon={FiPhone} /> Call 0433 037 815 <SafeIcon icon={FiArrowUpRight} /></a>
          <a className="button button-outline" href="https://wa.me/61433037815"><SafeIcon icon={FiMessageCircle} /> Text / WhatsApp</a>
          <a className="sms-link" href="sms:0433037815">Prefer SMS? Send Milan a text</a>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;